const resolveChildren = (groupId, groups, rules) => {
  const group = groups[groupId];

  return group.children.map(childId => {
    if (rules[childId]) {
      return { type: 'rule', data: rules[childId], id: childId };
    }

    if (groups[childId]) {
      return { type: 'group', data: groups[childId], id: childId };
    }

    return null;
  }).filter(Boolean);
};
export default resolveChildren;